import React from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";

// 페이지 애니메이션 변형 설정
const pageVariants = {
  initial: {
    opacity: 0,
  },
  animate: {
    opacity: 1,
    transition: {
      type: "tween",
      ease: "easeOut",
      duration: 0.5,
    },
  },
  exit: {
    opacity: 0,
    transition: {
      duration: 0.3,
    },
  },
};

const NotFoundPage = () => {
  const navigate = useNavigate();

  const handleButtonClick = () => {
    // 메인 페이지로 이동
    window.location.href = "https://www.theh-agreement.co.kr/";
  };

  return (
    <motion.div
      className="error-page"
      variants={pageVariants}
      initial="initial"
      animate="animate"
      exit="exit"
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        padding: "0 24px",
        backgroundColor: "#f7f9fc",
      }}
    >
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.2, duration: 0.5 }}
        style={{ marginBottom: "16px" }}
      >
        <h1
          style={{
            fontSize: "36px",
            color: "#333",
            marginBottom: "8px",
            textAlign: "center",
          }}
        >
          404
        </h1>
        <h2
          style={{
            fontSize: "24px",
            color: "#333",
            marginBottom: "24px",
            textAlign: "center",
          }}
        >
          잘못된&nbsp;접근입니다
        </h2>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.3, duration: 0.5 }}
        style={{ marginBottom: "32px", maxWidth: "500px", textAlign: "center" }}
      >
        <p style={{ color: "#666", lineHeight: 1.6 }}>
          이 페이지는 올바른 방법으로 접근할 수 없습니다.
          <br />
          유효한 접속 링크를 통해 다시 시도해주세요.
        </p>
      </motion.div>

      <motion.button
        onClick={handleButtonClick}
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.4, duration: 0.5 }}
        style={{
          backgroundColor: "#7A4FFF",
          color: "white",
          border: "none",
          borderRadius: "8px",
          padding: "14px 28px",
          fontWeight: "600",
          fontSize: "16px",
          cursor: "pointer",
          boxShadow: "0 4px 12px rgba(0, 117, 255, 0.2)",
        }}
        whileHover={{
          backgroundColor: "#0056cc",
          boxShadow: "0 6px 15px rgba(0, 117, 255, 0.3)",
        }}
        whileTap={{ scale: 0.98 }}
      >
        홈페이지로 이동
      </motion.button>
    </motion.div>
  );
};

export default NotFoundPage;
